import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import { TXTMOB_Playing_games_may_be_harmful_o_ELL } from './RegulatoryHeaderCZ.messages.json';
import styles from './RegulatoryHeaderCZ.scss';

const RegulatoryHeaderCZ: React.FC = () => (
  <div className={styles.regulatoryHeader}>
    <Translation {...TXTMOB_Playing_games_may_be_harmful_o_ELL} />
  </div>
);

export default RegulatoryHeaderCZ;
